import React, { useContext } from 'react';

import getInitialValues from '../../../../shared/components/AppointmentForm/getInitialValues';
import { SchedulingSessionStateContext } from '../../../../shared/components/SchedulingSessionState';
import { TrackSchedulingEvent } from '../../../../widgets/pages/SchedulingPage/types';
import type { IScheduleRequestAttempt } from '../../types';
import SchedulingBookedStep from './SchedulingBookedStep/SchedulingBookedStep';
import SchedulingDetailsStep from './SchedulingDetailsStep/SchedulingDetailsStep';
import SchedulingProgressStep from './SchedulingInProgressStep/SchedulingProgressStep';
import SchedulingLandingPage from './SchedulingLandingPage';
import SchedulingTimeSelectionStep from './SchedulingTimeSelectionStep';
import SchedulingWizard, { hasSelectedNewProvider } from './schedulingWizard';

type Props = {
  scheduleRequestAttempt: IScheduleRequestAttempt;
  trackSchedulingEvent: TrackSchedulingEvent;
};

export default function SchedulingPageBody({
  scheduleRequestAttempt,
  trackSchedulingEvent,
}: Props) {
  const {
    appointmentVerificationToken,
    scheduleRequest: {
      contactEmail,
      contactMobilePhone,
      lmReasonForVisit,
      patient,
      contactPatient,
      lmProviderId,
      scheduleAfter,
      clinicMapping: { lmOffice },
    },
  } = scheduleRequestAttempt;
  const { widgetSettings, trackerData } = useContext(SchedulingSessionStateContext);

  const initialProvider = lmProviderId ? { id: lmProviderId } : null;
  const { patientStatus, ...initialValues } = getInitialValues({
    provider: initialProvider,
    opening: null,
    widgetSettings,
    prefillToken: appointmentVerificationToken,
    trackerData,
    isScheduleRequest: true,
  });

  return (
    <SchedulingWizard
      initialValues={{
        ...scheduleRequestAttempt,
        ...initialValues,
        patientBirthDate: patient.birthdate,
        patientFamilyName: patient.familyName,
        patientGivenName: patient.givenName,
        contactEmail: contactEmail || contactPatient.email,
        contactMobilePhone: contactMobilePhone || contactPatient.mobilePhoneNumber,
        contactBirthDate: contactPatient.birthdate,
        contactFamilyName: contactPatient.familyName,
        contactGivenName: contactPatient.givenName,
        patient,
        reasonForVisit: lmReasonForVisit,
        verificationToken: appointmentVerificationToken,
        office: lmOffice,
        practice: lmOffice.lmPractice,
        scheduleAfter,
        queryProvider: initialProvider,
        start: false,
        selectedDate: new Date(),
        initialSelectedDate: new Date(),
      }}
      trackSchedulingEvent={trackSchedulingEvent}
    >
      <SchedulingLandingPage completed={(values) => !!values.start} autoStep />
      <SchedulingTimeSelectionStep
        completed={(values) =>
          values.selectedDate && values.opening && !hasSelectedNewProvider(values)
        }
      />
      <SchedulingDetailsStep completed={(values) => !!values.termAgreedAt} />
      <SchedulingProgressStep completed={(values) => values.selectedDate && values.opening} />
      <SchedulingBookedStep />
    </SchedulingWizard>
  );
}
